<template>
  <v-container grid-list-md>
    <profile></profile>
    <h1 class="headline">My Classes</h1>
    <v-layout class="mt-2" row wrap>
      <v-flex md3 v-for="(classroom, i) in classrooms" :key="classroom.classroom_id" >  
        <v-card>
          <v-card-media
            :src="'https://picsum.photos/1000/700?image='+i"
            height="100px"
          >
            <v-spacer></v-spacer>
            <v-tooltip bottom lazy>
              <v-menu offset-x slot="activator">
                <v-btn flat icon slot="activator" color="white">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="setEventAction(false, classroom.classroom_id)">
                    <v-list-tile-title>Edit</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="configDelete(classroom.classroom_id)">
                    <v-list-tile-title>Delete</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <span>More actions</span>
            </v-tooltip>
          </v-card-media>
          <v-card-title primary-title>
            <div>
              <router-link style="cursor: pointer;" class="underline" :to="'/admin/classroom/' + classroom.classroom_id">
                <div class="headline">{{classroom.classroom_name}}</div>
              </router-link>
              <div class="grey--text">Subject: {{ classroom.subject }}</div>
              <div class="grey--text">Section: {{ classroom.section }}</div>
              <div class="grey--text">Class Code: {{ classroom.classroom_id }}</div>
            </div>
          </v-card-title>
          <!-- <v-card-actions>
            <v-spacer></v-spacer>
            <v-tooltip bottom lazy>
              <v-menu offset-x slot="activator">
                <v-btn flat icon slot="activator">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>
                  <v-list-tile @click="setEventAction(false, classroom.classroom_id)">
                    <v-list-tile-title>Edit</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile @click="configDelete(classroom.classroom_id)">
                    <v-list-tile-title>Delete</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
              <span>More actions</span>
            </v-tooltip>
          </v-card-actions> -->
        </v-card>
      </v-flex>
    </v-layout>

    <!-- ACTION MODAL -->
    <v-dialog v-model="classDialog" persistent max-width="500px">
      <v-card>
        <v-card-title>
          <span class="headline">{{checkIfAdd ? 'Add' : 'Edit'}} a class</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <v-text-field
                  label="Name"
                  required
                  v-model.trim="classroomName"
                  :error-messages="classroomNameErrors"
                  @input="$v.classroomName.$touch()"
                  @blur="$v.classroomName.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Subject"
                  required
                  v-model.trim="subject"
                  :error-messages="subjectErrors"
                  @input="$v.subject.$touch()"
                  @blur="$v.subject.$touch()"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-text-field
                  label="Section"
                  required
                  v-model.trim="section"
                  :error-messages="sectionErrors"
                  @input="$v.section.$touch()"
                  @blur="$v.section.$touch()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="gray" flat @click.native="clearFormField">Cancel</v-btn>
          <v-btn color="blue darken-1" flat @click.native="addClass" v-if="checkIfAdd">Add</v-btn>
          <v-btn color="blue darken-1" flat @click.native="editClass" v-else>Edit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DELETE MODAL -->
    <v-layout row justify-center>
      <v-dialog v-model="deleteModal" persistent max-width="290">
        <v-card>
          <v-card-title class="headline">Warning!</v-card-title>
          <v-card-text>You are about to delete this classroom. Are you sure?</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="gray" flat @click.native="deleteModal = false">Cancel</v-btn>
            <v-btn color="red darken-1" flat @click.native="deleteClass">Delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>

    <v-tooltip left lazy>
      <v-speed-dial
        slot="activator"
        v-model="fab"
        :bottom="bottom"
        :right="right"
        :direction="direction"
        :transition="transition"
        fixed
      >
        <v-btn
          slot="activator"
          fab
          color="red darken-1"
          dark
          hover
          v-model="fab"
          @click="setEventAction(true)"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-speed-dial>
      <span>Add a classroom</span>
    </v-tooltip>
  </v-container>
</template>

<script>
import VueNotifications from 'vue-notifications'
import axios from 'axios'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import Profile from './Profile.vue'
export default {
  components: {
    Profile
  },
  mixins: [validationMixin],
  validations: {
    classroomName: {
      required
    },
    subject: {
      required
    },
    section: {
      required
    }
  },
  data(){
    return {
      fab: false,
      bottom: true,
      right: true,
      transition: 'slide-y-reverse-transition',
      direction: 'top',
      classDialog: false,
      classroomName: '',
      subject: '',
      section: '',
      checkIfAdd: null,
      editId: null,
      deleteModal: false,
      selectedId: null
    }
  },
  methods: {
    async addClass(){
      let { classroomName, subject, section } = this
      this.$v.$touch()

      if(!this.$v.$error){
        try{
          this.$Progress.start()
          let response = await axios.post('/api/class', {
            name: classroomName,
            subject,
            section
          }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
          this.$store.dispatch('admin/FETCH_CLASSES')
          this.clearFormField()
          this.classDialog = false
          this.showSuccessMsg({ title: 'Success!', message: 'Classroom added successfully!' })
          this.$Progress.finish()
        }catch(e){
          this.clearFormField()
          this.classDialog = false
          this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.message })
          console.log(e)
          this.$Progress.fail()
        }
      }
    },
    async editClass(){
      let { classroomName, subject, section, editId } = this
      this.$v.$touch()

      if(!this.$v.$error){
        try{
          this.$Progress.start()
          let result = await axios.put(`/api/class/${editId}`, {
            name: classroomName,
            subject,
            section
          }, { headers: { 'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}` } })
          this.$store.dispatch('admin/FETCH_CLASSES')
          this.clearFormField()
          this.classDialog = false
          this.showSuccessMsg({ title: 'Success!', message: 'Classroom details is updated successfully!' })
          this.$Progress.finish()
        }catch(e){
          this.clearFormField()
          this.classDialog = false
          this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.message })
          console.log(e)
          this.$Progress.fail()
        }
      }
    },
    async deleteClass(){
      // METHOD NOT ALLOWED YET
      try{
        let response = await axios.delete(`/api/class/${ this.selectedId }`, {
          headers: { 
            'Authorization': `Bearer ${this.$store.getters.GET_TOKEN}`
          }
        })
        this.$store.dispatch('admin/FETCH_CLASSES')
        this.clearFormField()
        this.deleteModal = false
        this.showSuccessMsg({ title: 'Success!', message: 'Classroom is deleted successfully!' })
        this.$Progress.finish()
      }catch(e){
        this.clearFormField()
        this.deleteModal = false
        this.showErrorMsg({ title: e.response.statusText, message: e.response.data.error.message })
        console.log(e)
        this.$Progress.fail()
      }
    },
    unenroll(){

    },
    configDelete(id){
      this.deleteModal = true
      this.selectedId = id
    },
    setEventAction(action, id){
      // If action is true then it is add, else it is false
      this.checkIfAdd = action ? true : false
      // If edit is clicked
      if(!action) {
        let details = this.$store.getters['admin/GET_CLASSES'].find(el => {
          return el.classroom_id === id
        })
        this.editId = id
        this.classroomName = details.classroom_name
        this.subject = details.subject
        this.section = details.section
      }

      this.classDialog = true
    },
    clearFormField(){
      this.classroomName = ''
      this.subject = ''
      this.section = ''
      this.classDialog = false
    }
  },
  created(){
    this.$store.dispatch('admin/FETCH_CLASSES')
  },
  computed: {
    classroomNameErrors(){
      const errors = []
      if(!this.$v.classroomName.$dirty) return errors
      !this.$v.classroomName.required && errors.push('Classroom Name is required')
      return errors
    },
    subjectErrors(){
      const errors = []
      if(!this.$v.subject.$dirty) return errors
      !this.$v.subject.required && errors.push('Subject is required')
      return errors
    },
    sectionErrors(){
      const errors = []
      if(!this.$v.section.$dirty) return errors
      !this.$v.section.required && errors.push('Section is required')
      return errors
    },
    classrooms(){
      return this.$store.getters['admin/GET_CLASSES']
    }
  },
  notifications: {
    showSuccessMsg: { type: VueNotifications.types.success },
    showErrorMsg: { type: VueNotifications.types.error }
  }
}
</script>

<style>
.swal-title,
.swal-text,
.swal-button{
  font-family: 'Roboto',sans-serif;
}

.swal-button{
  background-color: #43a047;
}

.underline{
  text-decoration: none;
}

.underline:hover{
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/components/Admin/Classrooms.vue